import temperatureUtils from "@/utils/temperature"

export default (value, units) => {
  if (value !== undefined && value != null) {
    return temperatureUtils.convertFromCelcius(value, units)
  }
  return value
}
